<div class="sub-nav-layout">
  <div class="sticky-header">
    <dxo-top-nav
      logoImg="/assets/images/symetra_logo.svg"
      logoText="benefits"
      [username]="userFullName"
      [accountMenuItems]="topRightMenuItems"
    ></dxo-top-nav>
  </div>
  <div class="sub-nav-wrapper">
    <app-sub-nav
      [returnPath]="returnPath"
      [returnPathType]="returnPathType"
      [currentPath]="currentPath || ''"
      [links]="links || []"
    ></app-sub-nav>
  </div>
  <main>
    <div class="main-content-wrapper">
      <ng-content></ng-content>
    </div>
  </main>
  <app-portal-timeout-modal [countdownTimeSeconds]="initialCountdown" (logout)="logout()"></app-portal-timeout-modal>
  <app-footer></app-footer>
</div>